import { RoleUsersTablePanel } from "#src/batteries-included-components/Panels";
import classNames from "classnames/bind";
import React from "react";
import styles from "./RoleUsersTab.module.scss";

const cx = classNames.bind(styles);

export const RoleUsersTab = () => {
  return (
    <div className={cx("container")}>
      <div className={cx("contentContainer")}>
        <RoleUsersTablePanel />
      </div>
    </div>
  );
};
